export default __webpack_public_path__ + "static/media/Ato-Consitutivo-de-Sociedade-Unipessoal.44716f14.docx";